var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-store"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19464",
    x: 5,
    y: 12,
    width: 16,
    height: 9,
    fill: "#EB595D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19465",
    x: 5.31836,
    y: 4.72656,
    width: 15.9545,
    height: 4.13636,
    fill: "#EB595D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6667 4.33203H4.33333V6.4987H21.6667V4.33203ZM22.75 15.1654V12.9987L21.6667 7.58203H4.33333L3.25 12.9987V15.1654H4.33333V21.6654H15.1667V15.1654H19.5V21.6654H21.6667V15.1654H22.75ZM13 19.4987H6.5V15.1654H13V19.4987Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreFilled);
export default __webpack_public_path__ + "static/media/storeFilled.cb26c77800dc821918511899a1711c71.svg";
export { ForwardRef as ReactComponent };